import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import { mapState, mapGetters, mapMutations } from 'vuex';
import { GeoJSON } from 'ol/format';
import gpickr from '@/components/mapv2/gpickr';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
export default {
  name: 'maptools',
  components: {
    gpickr
  },
  meta: {
    title: ''
  },
  props: {
    maptemplate: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: []
    },
    drawelement: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      dtext: false,
      dline: false,
      ddelete: false,
      drawIndex: '',
      dialoglineVisible: false,
      lineform: {
        width: 1,
        linetype: '',
        color: 'rgba(0,0,0,0.5)',
        lineDash: [4, 2]
      },
      dialogtextVisible: false,
      transfervalue: [],
      defaulttransferList: [],
      transferList: [],
      drawtextblocksum: 0,
      textform: {
        align: 0,
        // 排列方式 0纵向 1横向
        fontSize: 12,
        color1: 'rgba(0, 0, 0, 1)',
        color2: 'rgba(123, 33, 33, 1)',
        fontSpace: 4
      }
    };
  },
  created() {},
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {
    list: {
      handler(val) {
        if (val) {
          this.defaulttransferList = [...this.list];
          this.transferList = this.list;
          this.init();
        }
      },
      deep: true
    },
    'mapv2info.drawlayer.showtranfer'(val) {
      console.log(`mapv2info.view.showtranfer`, val);
      this.dialogtextVisible = val;
    },
    'mapv2info.drawlayer.deleteList'(val) {
      if (val.length > 0) {
        this.transferList = this.transferList.concat(val);
        this.SET_MAPDRAWLAYERITEM({
          deleteList: []
        });
      }
    }
  },
  mounted() {
    console.log('this.maptemplate');
    console.log(this.maptemplate);
    console.log(this.list);
    console.log(this.drawelement);
  },
  methods: {
    ...mapMutations(['SET_MAPDRAWLAYERITEM']),
    init() {
      if (Object.keys(this.drawelement).length > 0) {
        if (this.drawelement.drawJson) {
          let data = this.drawelement;
          let useList = [];
          const featureJson = new GeoJSON().readFeatures(data.drawJson);
          featureJson.forEach((elem, index) => {
            if (elem.get('name')) useList.push({
              key: elem.get('id'),
              label: elem.get('name')
            });
          });
          this.transferList = this.transferList.filter(item1 => !useList.some(item2 => item2.key === item1.key));
          // this.transfervalue = []
          // console.log(this.transferList)
        }
      }
    },
    /**
     * 地图操作按钮
    * @param {Number} index 操作类型 0绘制文字 1绘制线 2删除 3框选 4平移
     */
    toolsHandle(index) {
      console.log(`index`, index);
      this.drawIndex = index;
      this.dialoglineVisible = false;
      this.SET_MAPDRAWLAYERITEM({
        showtranfer: false
      });
      this.SET_MAPDRAWLAYERITEM({
        toolsIndex: index
      });
      if (index === 6) this.dialoglineVisible = true;
    },
    /**
     * 绘制线段改变参数时触发
    * @param {data} val 改变值数据
    * @param {String} type 属性名称
     */
    drawLineChange(val, type) {
      if (type === 'color') {
        this.lineform.color = val;
      }
      if (type === 'type') {
        let borderstyle = [];
        switch (val) {
          case 2:
            borderstyle = [2, 2, 4];
            break;
          case 3:
            borderstyle = [4, 2];
            break;
          case 4:
            borderstyle = [2, 2];
            break;
          default:
            borderstyle = [];
            break;
        }
        this.lineform.lineDash = borderstyle;
      }
      let style = {
        ...this.lineform
      };
      delete style.linetype;
      console.log(style);
      this.SET_MAPDRAWLAYERITEM({
        linestyle: style
      });
    },
    /**
     * 穿梭框右侧列表元素变化时触发
    * @param {Array} value 改变值数据
    * @param {String} direction 改变值left/right
    * @param {Array} movedKeys
     */
    transferChange(value, direction, movedKeys) {
      let list = this.defaulttransferList.filter(item => {
        return value.includes(item.key);
      });
      console.log(list);
      this.SET_MAPDRAWLAYERITEM({
        currentList: list
      });
    },
    textClose() {
      this.SET_MAPDRAWLAYERITEM({
        currentList: []
      });
      this.SET_MAPDRAWLAYERITEM({
        showtranfer: false
      });
    },
    textconfirm() {
      console.log('确定');
      let data = this.mapv2info.drawlayer;
      this.drawtextblocksum++;
      if (this.transfervalue.length > 0) {
        let textstyle = {
          ...data.textstyle
        };
        textstyle[this.drawtextblocksum] = {
          ...this.textform
        };
        this.SET_MAPDRAWLAYERITEM({
          textstyle: textstyle
        });
      } else {
        ElMessage({
          message: '右侧列表无数据，请选择后点击确定按钮',
          type: 'warning'
        });
        return;
      }
      this.transferList = this.transferList.filter(item1 => !data.currentList.some(item2 => item2.key === item1.key));
      this.transfervalue = [];
      this.SET_MAPDRAWLAYERITEM({
        drawtextblocksum: this.drawtextblocksum
      });
      this.SET_MAPDRAWLAYERITEM({
        showtranfer: false
      });
    },
    inputChange(val) {
      console.log(val);
      console.log(this.textform);
      this.SET_MAPDRAWLAYERITEM({
        currentTextstyle: this.textform
      });
    }
  }
};